import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { ChartTooltip } from "./ChartTooltip";
const CHART_HEIGHT_PX = 256; // h-64 = 16rem = 256px
export const ChartBar = ({ data, maxValue })=>{
    const [showTooltip, setShowTooltip] = useState(false);
    const heightPercentage = maxValue > 0 ? data.total / maxValue * 100 : 0;
    // Calculate pixel height from percentage (256px is the container height)
    const heightPx = Math.max(heightPercentage / 100 * CHART_HEIGHT_PX, 2);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col justify-end h-full relative group w-10 shrink-0 grow",
        children: /*#__PURE__*/ _jsx("div", {
            className: "bg-navy-70 rounded-t-sm transition-all duration-300 hover:bg-navy-80 cursor-pointer",
            style: {
                height: `${heightPx}px`
            },
            onMouseEnter: ()=>setShowTooltip(true),
            onMouseLeave: ()=>setShowTooltip(false),
            children: /*#__PURE__*/ _jsx(ChartTooltip, {
                value: data.total,
                unit: data.unit || 'KB',
                isVisible: showTooltip
            })
        })
    });
};
